import { render } from "./RacesMain.vue?vue&type=template&id=e2a92358&scoped=true"
import script from "./RacesMain.vue?vue&type=script&lang=js"
export * from "./RacesMain.vue?vue&type=script&lang=js"

import "./RacesMain.vue?vue&type=style&index=0&id=e2a92358&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a92358"]])

export default __exports__